export const table = {
  name: 'box',
  columns: [
    'identifier',
    'name',
    'compartments.length',
  ],
  disabledColumns: [
    'compartments',
  ]
};

export const tableCompartments = {
  name: 'compartment',
  columns: [
    'identifier',
    'name',
  ],
  disabledColumns: []
};

export const boxSearchQueryFields = 'identifier,name,compartments.identifier,compartments.name';

export const compartmentSearchQueryFields = 'identifier,name';
